import { useEffect, useState } from "react";
import Picker from "react-mobile-picker";
import moment from "moment";
import "./index.css";
export type SliderDateTimeProps = {
  style?: React.CSSProperties
  options: {
    type: "year" | "month" | "day" | "hour" | "minutes" | "ap" | "countdown";
    defaultValue: string;
    cb(value: string): void;
  };
};
function SliderDateTime(props: SliderDateTimeProps) {
  const { options } = props;

  let classArr = ["border-4 bg-[#406F70] setting-date-time float-left"];
  let datas = [];
  if (options.type === "year") {
    for (let i = 1900; i <= moment().add(40, 'year').year(); i++) {
      datas.push({ key: i.toString(), value: i.toString() });
    }

    classArr.push("w-20 mr-4");
  }

  const monthAbbr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (options.type === "month") {
    for (let i = 1; i <= 12; i++) {
      datas.push({
        key: i.toString(),
        value: i.toString(),
      });
    }

    classArr.push("w-16 mr-4");
  }

  if (options.type === "day") {
    for (let i = 1; i <= moment().daysInMonth(); i++) {
      datas.push({
        key: i.toString(),
        value: i.toString(),
      });
    }
    classArr.push("w-12 mr-4");
  }

  if (options.type === "hour") {
    for (let i = 1; i <= 11; i++) {
      datas.push({
        key: i.toString(),
        value: i.toString(),
      });
    }
    classArr.push("w-12 ml-[40px]");
  }

  if (options.type === "minutes") {
    for (let i = 0; i <= 59; i++) {
      datas.push({
        key: i.toString(),
        value: i.toString(),
      });
    }
    classArr.push("w-12 ml-4");
  }

  if (options.type === "ap") {
    datas.push({
      key: "AM",
      value: "AM",
    });
    datas.push({
      key: "PM",
      value: "PM",
    });
    classArr.push("w-16 ml-4");
  }

  if (options.type === "countdown") {
    for (let i = 5; i <= 60; i += 5) {
      datas.push({
        key: i.toString(),
        value: i.toString(),
      });
    }

    classArr.push("w-24 ml-[190px] text-4xl");
  }

  const pickerData = {
    data: datas,
  };

  const [pickerValue, setPickerValue] = useState({
    data: options.defaultValue,
  });

  function onChangePicker(data: any) {
    options.cb(data.data);
  }

  // 重置组件
  useEffect(() => {
    setPickerValue({
      data: options.defaultValue,
    });
  }, [options.defaultValue]);

  return (
    <Picker
      style={{
        borderColor: 'white',
        ...props.style || {
        },
      }}
      value={pickerValue}
      onChange={onChangePicker}
      height={options.type === "countdown" ? 180 : 120}
      itemHeight={options.type === "countdown" ? 60 : 40}
      className={classArr.join(" ")}
    >
      <Picker.Column key={"data"} name={"data"}>
        {pickerData.data.map((option) => (
          <Picker.Item key={option.key} value={option.value}>
            {({ selected }) => (
              <div
                style={{
                  fontSize: selected
                    ? options.type === "countdown"
                      ? "36px"
                      : "24px"
                    : options.type === "countdown"
                      ? "24px"
                      : "18px",
                  color: selected ? "white" : "#cccccc",
                  marginBottom: "5px",
                }}
                className="font-bold"
              >
                {options.type === "month"
                  ? monthAbbr[Number(option.value) - 1]
                  : option.value}
              </div>
            )}
          </Picker.Item>
        ))}
      </Picker.Column>
    </Picker>
  );
}

export default SliderDateTime;
